import api from "./api";
import StorageService from "./StorageService";

const FuelPurchaseService = {

  create: async (data) => {
    const login = StorageService.loginData();
    const comp = StorageService.activeCompany();

    // const payload = {
    //   ...data,
    //   companyId: comp.companyId,
    //   createdBy: login.employeeId,
    //   updatedBy: login.employeeId,
    // };
    const payload = {
      ...data,
      companyId: comp.companyId,
      projectId: Number(data.projectId),
      vendorId: Number(data.vendorId),
      fuelQuantityLiters: Number(data.fuelQuantityLiters),
      costperLiter: Number(data.costperLiter),
      createdBy: login.employeeId,
      updatedBy: login.employeeId,
    };

    const res = await api.post("/fuelPurchase/save", payload);
    return res.data;
  },

    getAll: async ({ projectId = null, type = null, employeeId = null, roleId = null } = {}) => {
        const comp = StorageService.activeCompany();
        const emp = StorageService.loginData();

        const res = await api.get("/fuelPurchase/getAll", {
            params: {
                companyId: comp.companyId,
                projectId: projectId ? Number(projectId) : null,
                type: type ? type.toUpperCase() : null,
                employeeId: employeeId !== undefined && employeeId !== null ? employeeId : emp?.employeeId,
                roleId: roleId !== undefined && roleId !== null ? roleId : emp?.roleId,
            },
        });

        return res.data;   // ⬅ important
    },

  getById: async (id) => {
    const res = await api.get(`/fuelPurchase/getById/${id}`);
    return res.data.data;
  },

  update: async (id, data) => {
    const login = StorageService.loginData();
    const comp = StorageService.activeCompany();

    // const payload = {
    //   ...data,
    //   companyId: comp.companyId,
    //   updatedBy: login.employeeId,
    // };
    
      const payload = {
        ...data,
        companyId: comp.companyId,
        projectId: Number(data.projectId),
        vendorId: Number(data.vendorId),
        fuelQuantityLiters: Number(data.fuelQuantityLiters),
        costperLiter: Number(data.costperLiter),
        updatedBy: login.employeeId,
      };
    

    const res = await api.put(`/fuelPurchase/update/${id}`, payload);
    return res.data;
  },

  remove: async (id) => {
    const res = await api.delete(`/fuelPurchase/${id}`);
    return res.data;
  },
};

export default FuelPurchaseService;